import { Dialog, Loader } from "@/components"
import useViewGroupGl from "./useViewGroupGl";

const ViewGroupGl = ({
  open,
  setOpen,
  groupGlMasterId
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  groupGlMasterId: string
}) => {
  const {groupGlList, isGroupLoading} = useViewGroupGl({groupGlMasterId});

  return (
    <Dialog open={open} setOpen={setOpen}
      title={
        <div className="text-2xl font-bold text-primary">
          {"View Group GL(s)"}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>
      }
    >
      <div className="flex flex-col">
        {isGroupLoading ? <Loader /> :
          groupGlList?.length ? groupGlList?.map((data: any) => {
            return (
              <span>{data?.glAccountNumber} - {data?.accountShortDesc}</span>
            )
          }) : <span>No Data Found</span>
        }
      </div>
    </Dialog>
  )
}

export default ViewGroupGl;